(ns frontend.view.grid.zap-vaults-grid.sub
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.state.current-session :as session]
            [frontend.view.grid.zap-vaults-grid.model :as model]
            [re-frame.core :as rf]
            [ui.state.session.sub :as session-sub]
            [ui.view.card.entity-list.util :as entity-list-util]))

(rf/reg-sub
  ::state
  (fn [db _]
    (get-in db model/root-path)))

(rf/reg-sub
  ::loading?
  :<-
  [::state]
  (fn [state _]
    (get state model/loading-key)))

(rf/reg-sub
  ::search-text
  :<-
  [::state]
  (fn [state _]
    (get state model/search-text-key)))

(rf/reg-sub
  ::show-inactive?
  :<-
  [::state]
  (fn [state _]
    (get state model/show-inactive-key)))

(rf/reg-sub
  ::show-only-my?
  :<-
  [::state]
  (fn [state _]
    (get state model/show-only-my-key)))

(rf/reg-sub
  ::vaults
  (fn [_db _]
    @session/zap-vaults))

(rf/reg-sub
  ::table-columns
  (fn [_db _]
    [{:field            :zap-vault/name
      :open-button-text (loc/tr :open)}
     {:field :zap-vault/description}
     {:field :common/owner}
     {:field :common/created-on}
     {:field :common/archived?}]))

(rf/reg-sub
  ::table-data
  :<-
  [::table-columns]
  :<-
  [::vaults]
  :<-
  [::session-sub/entities]
  :<-
  [::session-sub/legacy-entities]
  :<-
  [::session-sub/tenant]
  :<-
  [::session-sub/tenant-schema]
  :<-
  [::show-only-my?]
  :<-
  [::show-inactive?]
  :<-
  [::search-text]
  (fn [[columns vaults global-entities-by-id legacy-entities tenant tenant-schema only-my? inactive? search-text] _]
    (let [all-entities-by-id (merge global-entities-by-id legacy-entities)
          my-id @session/account-id
          column-fields (mapv :field columns)
          shown-vaults (if-not only-my?
                         vaults
                         (->> vaults
                              (cu/filter-by :common/owner my-id)))
          filtered-vaults (if inactive?
                            shown-vaults
                            (->> shown-vaults
                                 (remove :common/archived?)))
          matching-vaults (if (cu/blank-value? search-text)
                            filtered-vaults
                            (->> filtered-vaults
                                 (filter (fn [v]
                                           (string/includes? (cu/str-trim-lcase (:zap-vault/name v)) (cu/str-trim-lcase search-text))))))]
      (entity-list-util/entities->table-row-data
        {:entities       matching-vaults
         :column-fields  column-fields
         :entities-by-id all-entities-by-id
         :tenant         tenant
         :tenant-schema  tenant-schema}))))
